var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#899EA8",
    d: "M48.861 4.714h-3.139l3.14 7.857H52V7.857c0-1.728-1.412-3.143-3.139-3.143z",
    transform: "translate(-685.000000, -383.000000) translate(309.000000, 178.000000) translate(376.000000, 205.000000) translate(9.000000, 13.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#BCC4CB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 0H0v7.857h29.139V3.143C29.139 1.414 27.726 0 26 0zM29.139 31.429L26 39.286h3.139c1.726 0 3.139-1.414 3.139-3.143v-1.571l-3.14-3.143z",
    transform: "translate(-685.000000, -383.000000) translate(309.000000, 178.000000) translate(376.000000, 205.000000) translate(9.000000, 13.000000) translate(19.722320, 4.714180)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D3DAE0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.861 31.429v-4.715L0 29.857v1.572c0 1.728 1.412 3.143 3.139 3.143h42.583c1.727 0 3.14-1.415 3.14-3.143z",
    transform: "translate(-685.000000, -383.000000) translate(309.000000, 178.000000) translate(376.000000, 205.000000) translate(9.000000, 13.000000) translate(0.000000, 9.428462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.861 0h-3.139l3.14 29.857H52V3.143C52 1.414 50.588 0 48.861 0z",
    transform: "translate(-685.000000, -383.000000) translate(309.000000, 178.000000) translate(376.000000, 205.000000) translate(9.000000, 13.000000) translate(0.000000, 9.428462)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EEF2",
    d: "M48.861 12.571c0-1.728-1.412-3.142-3.139-3.142H29.14l-4.537-6.814C23.645 1.177 21.45 0 19.722 0H3.14C1.412 0 0 1.414 0 3.143v36.143h48.861V12.57z",
    transform: "translate(-685.000000, -383.000000) translate(309.000000, 178.000000) translate(376.000000, 205.000000) translate(9.000000, 13.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.264796b9.svg";
export { ForwardRef as ReactComponent };